import NavigateBackComponent from './NavigateBackComponent.js';

export default NavigateBackComponent;
